import React from 'react';
import './FloatAnalytics.css';

export function FloatAnalytics() {
  return (
    <div className="float-analytics">
      <img
        src="/images/aimers_chart_3d.jpg"
        alt="AIMERS 3D Analytics Card"
        className="float-analytics__img"
      />
    </div>
  );
}
